import React from "react";
import { useCallback, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { TopNav } from "./top-nav";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Footer from "../../Footer";
import { SideNav } from "./side-nav";

const LayoutRoot = styled("div")(({ theme }) => ({
  padding: 12,
}));

const LayoutContainer = styled("div")({});

export const Layout = (props) => {
  const { isAuth } = props;
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [openNav, setOpenNav] = useState(false);
  const logged = isAuth;

  const handlePathnameChange = useCallback(() => {
    if (openNav) {
      setOpenNav(false);
    }
  }, [openNav]);

  useEffect(
    () => {
      handlePathnameChange();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pathname]
  );

  useEffect(() => {
    if (isAuth === true) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth]);

  return (
    <>
      <TopNav onNavOpen={() => setOpenNav(true)} />
      <SideNav onClose={() => setOpenNav(false)} open={openNav} />
      <LayoutRoot>
        <LayoutContainer>
          <Outlet
            context={{
              // institutionId,
              isAuth: isAuth,
              logged: logged,
              // layoutRef: layoutRef,
            }}
          />
          <Footer />
        </LayoutContainer>
      </LayoutRoot>
    </>
  );
};
